import React from 'react';
import { connect } from 'react-redux';
import { toggleFilterCategory } from '../../../redux/actions';

import { FilterItem } from '../styles';

type Props = {
  onClickCategory(params: { id: number }): void;
  categories: {
    [key: string]: { name: string; id: number };
  };
  toggleFilterCategory(params: { subItemId: number; itemId: number }): void;
};

class Categories extends React.Component<Props> {
  render() {
    const {
      onClickCategory,
      categories,
      toggleFilterCategory: toggleFilterCategoryAction,
    } = this.props;

    return Object.keys(categories).map(categoryKey => {
      const category = categories[categoryKey];

      return (
        <FilterItem
          key={category.id}
          name={category.name}
          onClick={() => {
            onClickCategory(category);
            toggleFilterCategoryAction({
              itemId: category.id,
              subItemId: 0,
            });
          }}
        />
      );
    });
  }
}

const mapStateToProps = state => ({
  categories: state.filters.categories,
});

export default connect(
  mapStateToProps,
  { toggleFilterCategory },
)(Categories);
